module.exports = __webpack_public_path__ + "img/icon-desc.9655a73a.svg";